module.exports = __webpack_public_path__ + "static/header_background_mobile-aafd2914df431b7c897ecc779eddc879.png";